import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SignatureInputComponent} from './signature-input.component';
import {SignaturePadModule} from 'angular2-signaturepad';
import {SignatureModalComponent} from './signature-modal.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule, SignaturePadModule],
    declarations: [SignatureInputComponent, SignatureModalComponent],
    entryComponents: [SignatureModalComponent],
    exports: [SignatureInputComponent],
})
export class SignatureInputModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/signature/signature-input.module.ts